module.exports = __webpack_public_path__ + "static/media/Snithzel panini.55ca352b.jpg";